module.exports = __webpack_public_path__ + "img/info-01.1599e6d8.png";